export enum LevelOfEvidence {
  A = "a",
  B = "b",
  C = "c",
  D = "d",
  E = "e",
  F = "f",
}
